import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from '../../../services/Auth';

class MisteryMisteryReportsApi extends Api {
  constructor() {
    super('mistery/mistery_reports/');
  }

  getPDF(id) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/mistery/mistery_reports/${id}/file`,
      method: 'get',
      data: {},
      params: {},
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  }
}

export default MisteryMisteryReportsApi;
